import { render, staticRenderFns } from "./LevelForm.vue?vue&type=template&id=22550e9d&scoped=true&"
import script from "./LevelForm.vue?vue&type=script&lang=js&"
export * from "./LevelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22550e9d",
  null
  
)

export default component.exports